// License: GNU General Public License v3. See license.txt

if (!window.platia_erp) window.platia_erp = {};

platia_erp.subscribe_to_newsletter = function (opts, btn) {
	return platia_tech.call({
		type: "POST",
		method: "platia_tech.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: { email: opts.email },
		callback: opts.callback,
	});
};
